function toggleMenuOverlay() {
  const menuOverlay = document.querySelector('[data-js="MobileMenu"]')
  if (menuOverlay) {
    menuOverlay.classList.toggle('open')
  }
}

function toggleSubMenu(event: Event) {
  const target = event.currentTarget as HTMLElement
  const subMenu = target.parentElement?.querySelector('.sub-menu')

  if (subMenu) {
    subMenu.classList.toggle('open')
  }
}

function initializeMobileMenu() {
  const menuToggle = document.querySelector('[data-js="MobileMenuToggle"]')
  const menuItemsWithChildren = document.querySelectorAll(
    '[data-js="MobileMenuNav"] .menu-item-has-children'
  )

  const topLevelMenuItemsHasChildren = Array.from(menuItemsWithChildren).filter(
    (menuItem) => menuItem.parentElement?.classList.contains('sub-menu') === false
  )

  console.log(topLevelMenuItemsHasChildren)

  if (menuToggle) {
    menuToggle.addEventListener('click', toggleMenuOverlay)
  }

  if (topLevelMenuItemsHasChildren) {
    topLevelMenuItemsHasChildren.forEach((menuItem) => {
      const clickableElement = document.createElement('span')
      clickableElement.classList.add('submenu-toggle')
      clickableElement.addEventListener('click', (event) => {
        toggleSubMenu(event)
        clickableElement.classList.toggle('open')
      })
      menuItem.querySelector('a')?.after(clickableElement)
    })
  }
}

export default initializeMobileMenu
